// extracted by mini-css-extract-plugin
module.exports = {"dialogWrap":"ActionConfirmDialog_dialogWrap__3UKd1","closeIconWrap":"ActionConfirmDialog_closeIconWrap__2msHN","infoIconWrap":"ActionConfirmDialog_infoIconWrap__3bbZj"};